import request from '@/utilsCloud/request'
import port from './port'

// 获取看课拍照
export function getUploadPhoto(data) {
  console.log(data)
  return request({
    url: '/system/common/uploadImage',
    headers: {
      isToken: true,
      isFile: true,
    },
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/apiCloud/uploadPhoto.js